/*
 * ログイン, ログアウト（api create）
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_AUTH_LOGIN = 'API_AUTH_LOGIN';
export const API_AUTH_LOGIN_SUCCESS = 'API_AUTH_LOGIN_SUCCESS';
export const API_AUTH_LOGIN_FAILURE = 'API_AUTH_LOGIN_FAILURE';
/**
 * ログイン（api）
 * @description Saga 内実行用。ページからログインする場合 authLogin action を使用
 * @param data
 * @param meta
 * @returns
 */
export const apiAuthLogin = (data, meta) => apiCreate(API_AUTH_LOGIN, '/auth/login', data.json, meta);
